import { render, staticRenderFns } from "./LinkInstruct.vue?vue&type=template&id=1a5e11a1&scoped=true"
import script from "./LinkInstruct.vue?vue&type=script&lang=js"
export * from "./LinkInstruct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e11a1",
  null
  
)

export default component.exports